import Median from './Median';

export default Median;
